export class ReportManagerConstant {
    static DefaultApplicationIdFields = [
        "application_id",
        // "rollid",
        // "roll_id",
        // "roll-id",
        // "roll_id",
        "appid",
        "app_id",
        "application-id",
        "app-id",
        "applicationid",
        "applicationid",
    ];
    static DefaultJobdFields = [
        "job_id",
        "jobid",
    ];
}
